import type { ReactElement } from 'react';
import { useContext } from 'react';
import { ODSSpinner } from 'bc-ods';
import { defineMessages, FormattedMessage } from 'react-intl';
import RegistrationForm from './RegistrationForm';
import { SmartLoginStateContext, FormStepEnum } from './context/SmartLoginContextProvider';
import SignInForm from './SignInForm';
import ForgotForm from './ForgotPassword';
import LoginUnavailable from './LoginUnavailable';
import SSOAccountDiscovered from './SSOAccountDiscovered';
import SSOChooseLinkOrRegister from './SSOChooseLinkOrRegister';
import SSOLinkAccount from './SSOLinkAccount';
import SSOLinkSuccess from './SSOLinkSuccess';
import SSOVerifyExistingAccount from './SSOVerifyExistingAccount';

const messages = defineMessages({
  signingIn: {
    id: 'SmartLoginForm.signingIn',
    defaultMessage: 'Signing in\u2026',
  },
});

function SmartLoginForm(): ReactElement {
  const { formStep, redirectLocationAfterLogin } = useContext(SmartLoginStateContext);

  if (formStep === FormStepEnum.Login) {
    window.location.href = redirectLocationAfterLogin!;

    return (
      <ODSSpinner className="pb-5 px-4">
        <FormattedMessage {...messages.signingIn} />
      </ODSSpinner>
    );
  }

  return (
    <div data-testid="login-form">
      {[FormStepEnum.AuthenticateAndLogin, FormStepEnum.Error, FormStepEnum.Login].includes(
        formStep
      ) && <SignInForm />}
      {formStep === FormStepEnum.Forgot && <ForgotForm />}
      {formStep === FormStepEnum.LoginUnavailable && <LoginUnavailable />}
      {formStep === FormStepEnum.Register && <RegistrationForm />}
      {formStep === FormStepEnum.SSOAccountDiscovered && <SSOAccountDiscovered />}
      {formStep === FormStepEnum.SSOChooseLinkOrRegister && <SSOChooseLinkOrRegister />}
      {formStep === FormStepEnum.SSOLinkAccount && <SSOLinkAccount />}
      {formStep === FormStepEnum.SSOLinkSuccess && <SSOLinkSuccess />}
      {formStep === FormStepEnum.SSOVerifyExistingAccount && <SSOVerifyExistingAccount />}
    </div>
  );
}

export default SmartLoginForm;
